import React from 'react';
import { getConfiguration } from '../../../data/utils/configuration';
import { getPrintableAmount } from '../../../data/utils/getPrintableAmount';
import { getUkCombinationName } from '../../../data/utils/getUkCombinationName';
import { isUKCombinationMaskEnabled } from '../../../data/utils/isUKCombinationMaskEnabled';
import { getLabel } from '../../../data/labels';

function BorderedTicketTuples(props) {
	const ticketData = props.ticketData;
	const conf = getConfiguration();
	const hideSystemLegend = conf.tad && conf.tad.hsl;
	const varSymb = getLabel('ticket.system.var_symb');
	const baseSymb = getLabel('ticket.system.base_symb');
	const pla = getLabel('ticket.system.pla');
	return (
        <>
        	{
        		!hideSystemLegend && (
	                <div  className="system-legend">
	                    <span className="banker">{baseSymb}</span> <span style={{verticalAlign:'middle'}}>{getLabel('printer.plain_ticket.tuples.fixed')}</span>
	                    <span style={{marginLeft : '8%'}}></span>
	                    <span className="banker">{varSymb}</span> <span style={{verticalAlign:'middle'}}>{getLabel('printer.plain_ticket.tuples.variable')}</span>
	                    <span style={{marginLeft : '8%'}}></span>
	                    <span className="star">*</span> <span style={{verticalAlign:'middle'}}>{getLabel('printer.plain_ticket.tuples.activate_bonus')}</span>
	                </div>
        		)
        	}

            <div className="div-table">
                <table className="combination-table">
                    <thead>
                        <tr>
                            <th>{getLabel('printer.plain_ticket.tuples.type')}</th>
                            <th>{getLabel('printer.plain_ticket.tuples.combs')}</th>
                            <th>{getLabel('printer.plain_ticket.tuples.bet_amount')}</th>
                            <th>{getLabel('printer.plain_ticket.tuples.min_winnings')}</th>
                            <th>{getLabel('printer.plain_ticket.tuples.max_winnings')}</th>
                        </tr>
                    </thead>
                    <tbody>
                    {ticketData.tuples.map(function(tupla) {
                        const reactKey = 'tupla-' + tupla.id;
                        return (
                            <tr key={reactKey}>
                            	{
                            		isUKCombinationMaskEnabled()?
                            		(<td >{getUkCombinationName(tupla.id, tupla.isAccumulator)}</td>)
                            		:
                            		(<td >{tupla.id}-{pla}</td>)
                            	}
                                
                                <td>{tupla.combs}</td>
                                <td>{getPrintableAmount(tupla.amount, conf.cs.m, conf.cs.nd)}</td>
                                <td>{getPrintableAmount(tupla.vMin, conf.cs.m, conf.cs.nd)}</td>
                                <td>{getPrintableAmount(tupla.vMax, conf.cs.m, conf.cs.nd)}</td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default BorderedTicketTuples;